/**
 * Do not edit directly
 */

export default "PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAxNiAxNiI+PHBhdGggZD0iTTEwLjkgMy4xICAgICAgICAgICBMMTAuMSAzLjkgICAgICAgICAgIEwxMy44IDcuNSAgICAgICAgICAgTDEgIDcuNSAgICAgICAgICAgTDEgIDguNSAgICAgICAgICAgTDEzLjggOC41ICAgICAgICAgICBMMTAuMSAxMi4xICAgICAgICAgICBMMTAuOSAxMi45ICAgICAgICAgICBMMTUuNyA4ICAgICAgICAgICBMMTAuOSAzLjEgICAgICAgICAgIFoiLz48L3N2Zz4=";